module.exports = "https://trybtryb-legacy.web.app/img/ripped-special-desktop.546e2f65.svg";